import React, { useState } from 'react';
import { Mail } from 'lucide-react';
import Layout from '../Layout';
import { postData } from '../../helpers/ApiSettings';
import { showToast } from '../../helpers/customToast';

const ForgotPasswordPage = () => {
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setSuccess(false);

        if (!email) {
            setError('Veuillez entrer votre adresse email');
            return;
        }

        setLoading(true);
        try {
            // console.log('Sending request for:', email);
            const response = await postData('/auth/forgot-password', {
                email: email
            });
            // console.log('Forgot password response:', response);

            if (response && response.data.ok) {
                setSuccess(true);
                showToast('Un email de réinitialisation vous a été envoyé', 'success');
            } else {
                console.error('Invalid response:', response);
                setError('Erreur lors de l\'envoi de l\'email de réinitialisation');
            }
        } catch (error) {
            console.error('Password reset error:', error);
            console.error('Error response:', error.response);
            console.error('Error data:', error.response?.data);
            
            if (error.response?.data?.error?.message) {
                setError(error.response.data.error.message);
            } else {
                setError('Une erreur est survenue. Veuillez réessayer.');
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <Layout>
            <div className="container my-5">
                <div className="row justify-content-center">
                    <div className="col-md-6 col-lg-6">
                        <div className="card shadow-sm">
                            <div className="card-body p-4">
                                <div className="text-center mb-4">
                                    <h2 className="mb-1">Mot de passe oublié</h2>
                                    <p className="text-muted">
                                        Entrez votre adresse email pour réinitialiser votre mot de passe
                                    </p>
                                </div>

                                {error && (
                                    <div className="alert alert-danger" role="alert">
                                        {error}
                                    </div>
                                )}

                                {success ? (
                                    <div className="text-center">
                                        <div className="alert alert-success" role="alert">
                                            Un email de réinitialisation a été envoyé à {email}.
                                            Veuillez vérifier votre boîte de réception et suivre les instructions.
                                        </div>
                                        <a href="/login" className="btn btn-primary">
                                            Retour à la connexion
                                        </a>
                                    </div>
                                ) : (
                                    <form onSubmit={handleSubmit}>
                                        <div className="mb-4">
                                            <label className="form-label">E-mail</label>
                                            <div className="input-group">
                                                <span className="input-group-text">
                                                    <Mail size={18} />
                                                </span>
                                                <input
                                                    type="email"
                                                    className="form-control"
                                                    value={email}
                                                    onChange={(e) => setEmail(e.target.value)}
                                                    placeholder="Entrez votre adresse email"
                                                    disabled={loading}
                                                />
                                            </div>
                                        </div>

                                        <button
                                            type="submit"
                                            className="btn btn-primary w-100"
                                            disabled={loading}
                                        >
                                            {loading ? (
                                                <>
                                                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                    Envoi en cours...
                                                </>
                                            ) : (
                                                'Réinitialiser le mot de passe'
                                            )}
                                        </button>

                                        <div className="text-center mt-4">
                                            <p className="mb-0">
                                                Vous vous en souvenez ?{' '}
                                                <a href="/login" className="text-primary text-decoration-none">
                                                    Retour à la connexion
                                                </a>
                                            </p>
                                        </div>
                                    </form>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    );
};

export default ForgotPasswordPage;